jQuery(document).ready(function($) {

  function fixedNavigation() {
    var siteHeader = $('.site-header');
    var nav;
    var kjs = false;
    var ojl = false;
    if ($('#primary-navigation').length) {
      nav = $('#primary-navigation');
    } else if ($('#primary-navigation-ojl').length) {
      nav = $('#primary-navigation-ojl');
      ojl = true;
    } else if ($('#primary-navigation-ecommerce').length) {
      nav = $('#primary-navigation-ecommerce');
      kjs = true;
    } else {
      return;
    }

    var top = nav.offset().top;
    var h = nav.height() + 'px';
    $(window).scroll(function() {
      var y = $(this).scrollTop();
      if (nav && siteHeader) {
        if ($(window).width() >= 1024) {
          if (y >= top) {
            nav.addClass('fixed');
            $('#masthead').addClass('fixed-navigation');
            $('#content').css('padding-top', h);
          } else {
            nav.removeClass('fixed');
            $('#masthead').removeClass('fixed-navigation');
            $('#content').css('padding-top', 0);
          }
        } else {
          if (kjs === true || ojl === true) {
            if (y > 10) {
              nav.addClass('subsite-fixed');
            } else {
              nav.removeClass('subsite-fixed');
            }
          }
        }
      }
      // $('.sticky-scroll-box').width($('.sticky-scroll-box').parent().width());
    });
  }

  function removeFixedClass() {
    if ($(window).width() < 1024) {
      $('#primary-navigation').removeClass('fixed');
    }
  }

  function toggleSearchBar() {
    var $searchIconHeader = $('.search-icon-header');
    var $searchBar = $('.header-search .search-form');
    if ($searchIconHeader.length) {
      $searchIconHeader.on('click', function() {
        if ($searchBar.hasClass('visible')) {
          $searchBar.hide().removeClass('visible');
        } else {
          $searchBar.show().addClass('visible');
        }
      });
    }

    $(document).mouseup(function(e) {
      //var container = $('div[id^="ajaxsearchlite"]');

      // if the target of the click isn't the container nor a descendant of the container

      if ($searchBar.hasClass('visible') && !$searchBar.is(e.target) && $searchBar.has(e.target).length === 0 && !$searchBar.is(e.target)) {
        $searchBar.hide();
        $searchBar.hide().removeClass('visible');
      }
    });


  }

  function matchHeights() {
    $('.layout-person-list .list-item').matchHeight();
    $('.widget-recent-products .product-row .product-row__product-info').matchHeight();
  }

  function eventsListingTabs() {
    if ($('#events-listing-tabs').length) {
      var $tab, $active_tab = getUrlParameter('active_tab');

      if($active_tab !== undefined && $active_tab == 'past') {
        $tab = 1;
      } else {
        $tab = 0;
      }
      $('#events-listing-tabs').tabs({
        active: $tab
      });
    }
  }

  function videoTabs() {
    if ($('#video-tabs').length) {

      $('#video-tabs').tabs({
        activate: function(event, ui) {
          var iframes = document.querySelectorAll('#video-tabs iframe');
          Array.prototype.forEach.call(iframes, iframe => {
            iframe.contentWindow.postMessage(JSON.stringify({ event: 'command',
          func: 'stopVideo' }), '*');
         });
        }
      });
    }
  }

  function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
      sURLVariables = sPageURL.split('&'),
      sParameterName,
      i;

    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split('=');

      if (sParameterName[0] === sParam) {
        return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
      }
    }
  }

  function showBottomDonate() {
    var bottom = $('#bottom-donate');
    $(window).scroll(function () {
      var y = $(this).scrollTop();
      if (y > 200) {
        bottom.addClass('show');
      } else {
        bottom.removeClass('show');
      }
    });
  }

  function triggerCommentForm() {
    if ($('.blog_post #comments').length) {
      var $commentFormTrigger = $('#comments .comment-form-trigger');
      var $commentForm = $('#comments .comment-respond');
      $commentFormTrigger.click(function() {
        if ($commentForm.is(':hidden')) {
          $commentForm.show();
          $commentFormTrigger.html('Sulje lomake');
        } else {
          $commentForm.hide();
          $commentFormTrigger.html('Kommentoi');
        }
      })
    }
  }

  function replaceDonationLinks() {
    $('a[href*="/lahjoituskohde/"]').each(function() {
      console.log('Replace');
      var $href = $(this).attr('href');
      var $id = $href.split("/lahjoituskohde/").pop();
      if ($.isNumeric($id)) {
        var $text = $(this).html();
        var $replacing_markup =
          '<div class="hero-donate-button" data-donation-id="'+$id+'" data-donation-label="'+$text+'">'
            +'<button class="main_btn">Auta lahjoittamalla nyt!</button'
          +'</div>'
        $(this).replaceWith($replacing_markup);
      }
    });
  }

  function radiosTriggers() {
    $('.donation-details-section .radio-options__option').click(function() {
      $(this).addClass('active');
      $(this).siblings('label').removeClass('active');
    });
  }

  function monthlyDonationAmount() {
    $('.donation-details-section .radio-options__option').click(function() {
      var amountValue = $("input[name='amount']:checked").val();
      $('input#monthly-donation-amount').val(amountValue);
      $(this).addClass('active');
      $(this).siblings('label').removeClass('active');
      $('.donation-details-section input.amount-optional').val('');
    });

    $('.donation-details-section input.amount-optional').on('input', function() {
      $('input#monthly-donation-amount').val($(this).val());
      $("input[name='amount']:checked").parent('label').removeClass('active');
    });
  }

  function patmosFormFieldsVisibility() {
    if ($('#patmospost-form').length) {
      var $target_fields = $('.trigger-field');

      var $target_checkboxes = $('#patmospost-form input[type="checkbox"]:not(#terms, #weeklyLetter)');

      if ($target_checkboxes.is(':checked')) {
        $target_fields.show();
      } else {
        $target_fields.hide();
      }

      $target_checkboxes.change(function() {
        if ($target_checkboxes.is(':checked')) {
          $target_fields.show();
        } else {
          $target_fields.hide();
        }
      });

    }
  }

  function kjsProductsFiltersTrigger() {
    if ($('.products-list-filters').length && $('.filter-products-trigger').length) {
      if (isProductSearchActive()) {
        $('.products-list-filters').show();
        $('.filter-products-trigger').addClass('open');
      }
      $('.filter-products-trigger').click(function() {
        if ($('.products-list-filters').is(':hidden')) {
          $('.products-list-filters').show();
          $(this).addClass('open');
        } else {
          $('.products-list-filters').hide();
          $(this).removeClass('open');
        }
      })
    }
  }

  function isProductSearchActive() {

    if (getUrlParameter('tuotehaku') !== undefined
        || getUrlParameter('tekija') !== undefined
        || getUrlParameter('textsearch') !== undefined
        || getUrlParameter('price_min') !== undefined
        || getUrlParameter('price_max') !== undefined) {
      return true;
    }

    return false;
  }

  function clearQueryVarUrls() {
    if ($('.custom-query-form').length) {
      $('.custom-query-form').submit(function(e){
        var emptyinputs = $(this).find('input, select').filter(function(){
            return !$.trim(this.value).length;  // get all empty fields
        }).prop('disabled',true);
      });
    }
  }

  function radioHeaderInfo() {
    var $radioHeaderInfo = $('.site-header__radio');
    if ($radioHeaderInfo.length) {
      if ($(window).width() < 768) {
      $radioHeaderInfo.appendTo('.mobile-radio-bar');
      } else {
        $radioHeaderInfo.prependTo('.site-header__container');
      }
    }
  }

  function patmosPostRequiredFields() {
    //var $trigger_mail_checkbox = $('#patmospost-form .highlights-container input[type="checkbox"]');
    var $trigger_checkboxes = $('#patmospost-form .highlights-container input[type="checkbox"]:not(#weeklyLetter)');
    var $required_fields_all = $('#firstname, #lastname, #email, #address, #zipcode, #city');
    var $required_fields_basic = $('#firstname, #lastname, #email');

    if ($trigger_checkboxes.is(':checked')) {
      $required_fields_all.parent('.register-field').addClass('required');
    } else {
      $required_fields_basic.parent('.register-field').addClass('required');
    }

    $trigger_checkboxes.change(function() {
      if ($trigger_checkboxes.is(':checked')) {
        $required_fields_all.parent('.register-field').addClass('required');
      } else {
        $required_fields_all.parent('.register-field').removeClass('required');
        $required_fields_basic.parent('.register-field').addClass('required');
      }
    });
  }

  function addWebkitOrientToTitles() {
    $(".widget-container .list-item__title a").each(function() {
      $(this).css('-webkit-box-orient', 'vertical');
    });
  }

  function campaignPageDonationProgressBar() {
    $(".campaign-page--stats-progress-bar .progress").each(function(){

      var $bar = $(this).find(".bar");
      var $val = $(this).find(".stats-percent-number span");
      var perc = parseInt( $val.text(), 10);

      $({p:0}).animate({p:perc}, {
        duration: 3000,
        easing: "swing",
        step: function(p) {
          $bar.css({
            transform: "rotate("+ (45+(p*1.8)) +"deg)", // 100%=180° so: ° = % * 1.8
            // 45 is to add the needed rotation to have the green borders at the bottom
          });
          $val.text(p|0);
        }
      });
    });
    $(".campaign-page--stats-progress-bar .dynamic-progress-circle").each(function(){

      var $val = $(this).find(".stats-percent-number span");
      var perc = parseInt( $val.text(), 10);
      var $progressCircle = $(this).find('.progress-circle circle');
      let $dashArray = 0 / 100;
      var $stopOffset = $(this).find('#score-gradient stop.end-offset');

      $({p:0}).animate({p:perc}, {
        duration: 2000,
        easing: "swing",
        step: function(p) {
          if (p < 10) {
            $stopOffset.attr("stop-color", "#535A7A");
          } else {
            $stopOffset.attr("stop-color", "#EF0F4F");
          }
          $dashArray = (3.145 * 150 * p) / 100;
          $progressCircle.attr("stroke-dasharray", $dashArray+ " 10000");
          $stopOffset.attr("offset", p);
          $val.text(p|0);
        }
      });
    });
  }

  radioHeaderInfo();
  fixedNavigation();
  toggleSearchBar();
  matchHeights();
  eventsListingTabs();
  videoTabs();
  showBottomDonate();
  triggerCommentForm();
  //replaceDonationLinks();
  radiosTriggers();
  monthlyDonationAmount();
  patmosFormFieldsVisibility();
  kjsProductsFiltersTrigger();
  clearQueryVarUrls();
  patmosPostRequiredFields();
  addWebkitOrientToTitles();
  campaignPageDonationProgressBar();

  $(window).resize(function() {
      fixedNavigation();
      removeFixedClass();
      radioHeaderInfo();
  });
});
